import React from "react"
import styled, {css} from "styled-components"
import { brandPink } from "../styles/colors"

const ButtonStyled = styled.button`
  padding: 5px;
  background-color: ${brandPink};
  color: white;
  border: none;
  border-radius: 3px;
  cursor: pointer;
  ${props => props.size === 'big' && css`
    display: flex;
    width: 100%;
    font-weight: 600;
    font-size: 1.5em;
    padding: 10px 20px;
    justify-content: center;
  `}
`

const Button = ({ children, ...props }) => {
  return <ButtonStyled {...props}>{children}</ButtonStyled>
}

export default Button
